import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getAppReportStats } from 'api';

// Then, handle actions in your reducers:
const appReportStatsSlice = createSlice({
  name: 'appReportStats',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    appReportStatsFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    appReportStatsFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    appReportStatsFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    appReportStatsResetState: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  appReportStatsFetchStart,
  appReportStatsFetchSuccess,
  appReportStatsFetchFail,
  appReportStatsResetState,
} = appReportStatsSlice.actions;

// The reducer
export const appReportStatsReducer = appReportStatsSlice.reducer;

// Asynchronous thunk action
export const appReportStatsFetch = (id: string) => (dispatch) => {
  dispatch(appReportStatsFetchStart());

  getAppReportStats(id)
    .then((appReportStats) => {
      dispatch(appReportStatsFetchSuccess(appReportStats.data));
    })
    .catch((error) => {
      dispatch(appReportStatsFetchFail(error));
    });
};
